var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLinkedin = function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-linkedin_svg__a)",
    fill: "#141413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.866.01A1.869 1.869 0 0 0 0 1.876c0 1.029.837 1.866 1.866 1.866a1.868 1.868 0 0 0 1.865-1.866A1.868 1.868 0 0 0 1.866.01ZM3.265 4.491H.464a.241.241 0 0 0-.241.242v9.016c0 .133.108.241.241.241h2.801a.241.241 0 0 0 .241-.241V4.733a.241.241 0 0 0-.24-.242ZM10.427 4.385c-1.026 0-1.926.312-2.476.821v-.473a.241.241 0 0 0-.241-.242H5.023a.241.241 0 0 0-.242.242v9.016c0 .133.108.241.242.241H7.82a.241.241 0 0 0 .241-.241v-4.46c0-1.28.236-2.074 1.41-2.074 1.158.001 1.245.852 1.245 2.15v4.384c0 .133.108.241.241.241h2.8a.241.241 0 0 0 .241-.241V8.803c0-2.057-.406-4.418-3.572-4.418Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgIconLinkedin;